<template>
  <form class="p-2" @submit.prevent="handleAddDropOff">
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">
          {{ isEdit ? $t("edit_drop_off") : $t("add_drop_off") }}
        </h4>
      </template>

      <template slot="body">
        <div class="form-group w-100">
          <label for="contact">{{ $t("contact") }}</label>
          <select
            class="form-control"
            style="height: 50px"
            v-model="dropOff.contact"
            id="contact"
            required
          >
            <option value="" disabled>
              {{ $t("select") }} {{ $t("contact") }}
            </option>
            <option
              v-for="contact in contacts"
              :value="contact"
              :key="contact.id"
            >
              {{ contact.name }}
            </option>
          </select>
        </div>

        <div class="form-group w-100">
          <label for="item">{{ $t("assign-item") }}</label>
          <Dropdown
            :items="dropdownData"
            @update:selectedItems="handleSelectedItems"
            :itemsSelected="selectedItems"
          />
          <p v-if="showError" class="text-error font-12 mb-0">
            {{ $t("select_one")}}
          </p>
        </div>

        <p class="font-12">
          {{ $t("no_contact")}}
          <span
            class="text-primary cursor-pointer"
            @click="$emit('open-contact')"
            > {{ $t("add_new_contact") }}</span
          >
        </p>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import ModalContainer from "../../../components/ModalContainer.vue";
import Dropdown from "./Dropdown.vue";

export default {
  name: "AddDropOffModal",
  components: {
    ModalContainer,
    Dropdown,
  },
  mounted() {
    this.dropdownData = [...this.selectedItems, ...this.items];
  },
  props: {
    show: Boolean,
    onCancel: Function,
    dropOffData: Object,
    items: Array,
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["contacts"]),
  },
  data() {
    return {
      dropOff: {},
      isEdit: false,
      selectedItems: this.initialValues?.items || [],
      dropdownData: [],
      showError: false,
    };
  },
  methods: {
    handleAddDropOff() {
      if (!this.selectedItems.length) {
        this.showError = true;
        return;
      }
      const payload = {
        ...this.dropOff,
        items: this.selectedItems,
      };
      if (this.isEdit) {
        this.$emit("edit-dropOff", payload);
        return;
      }
      this.$emit("add-dropOff", payload);
    },
    handleSelectedItems(selectedItems) {
      this.selectedItems = selectedItems;
    },
  },
  watch: {
    dropOffData: {
      handler(val) {
        if (val.contact) {
          this.isEdit = true;
          this.dropOff = { contact: val.contact };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
